import { useEffect, useState } from 'react';
import { store } from '~/Store';
import { Result, Button, Form, Skeleton } from 'antd';
import ParametersForm from './ParametersForm';
import moment from 'moment';
import {
  parseConfig,
  cleanUpEditedTask,
  extractConfigDefinitionTypesMap,
  extractConfigDefinitionSubTypesMap
} from 'Pages/Pipelines/CreateTask/helpers';
import Job from 'Pages/Pipelines/Jobs/Job';
import { LoadingOutlined } from '@ant-design/icons'

const SUCCESS = "success"
const ERROR = "error"

export default function Parameters({ node, destroy, startPolling, ...props }) {
  const now = moment().toISOString()
  const plugins = store.getState().explore.plugins
  const orchestrator = plugins['weaver-orchestrator'];

  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({})
  const [functionality, setFunctionality] = useState()
  const [feedback, setFeedback] = useState({})
  const [parametersForm] = Form.useForm();
  const [relevantJobs, setRelevantJobs] = useState([])

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const scheduleUid = node.id()
      const schedule = JSON.parse(await orchestrator.getSchedule({ scheduleUid }));
      setInitialValues(schedule.config)
      const functionalities = JSON.parse(await orchestrator.getFunctionalities());
      const _functionality = functionalities.find((f) => f.name === schedule.functionalityName && f.version === schedule.functionalityVersion)
      setFunctionality(_functionality)
      setIsLoading(false);
    })();
  }, []);

  const fetchAndStore = async () => {
    const scheduleUid = node.id();
    const jobs = JSON.parse(await orchestrator.getJobs({ scheduleUid }));
    const _relevantJobs = jobs.filter(job => {
      const isAfter = moment(job.started).isAfter(now);
      return isAfter;
    });
    setRelevantJobs(_relevantJobs);
  };

  const RunWithParams = async () => {
    try {
      const formValues = parametersForm.getFieldValue()
      const configDefTypesMap = extractConfigDefinitionTypesMap(functionality.configDefinition);
      const configDefSubTypesMap = extractConfigDefinitionSubTypesMap(functionality.configDefinition)

      for (const key in configDefSubTypesMap) {
        if (configDefSubTypesMap[key] === 'json5-with-vars' && formValues[key + '-vars'] !== undefined) {
          formValues[key] = Weaver.Attribute.updateWithVars(formValues[key], formValues[key + '-vars'])
          delete formValues[key + '-vars']
        }
      }

      const scheduleUid = node.id()
      const parsedConfig = await parseConfig(formValues, configDefTypesMap);
      const cleaned = cleanUpEditedTask({ scheduleUid, config: parsedConfig });
      await orchestrator.updateConfiguration(cleaned)
      await orchestrator.runOnce({ scheduleUid })
      setFeedback({
        type: SUCCESS,
        message: "Task created successfully. Wait for the job tile to appear below or check the tasks table for job status.",
        extra: undefined
      })
    } catch (e) {
      setFeedback({
        type: ERROR,
        message: "We encountered an issue with the service, and it didn't function as expected.",
        extra:
          <Button
            type="text"
            onClick={() => setFeedback(undefined)}
          >
            Try another file
          </Button>
      })
      console.error(e)
    }
  };

  return (
    <Skeleton active loading={isLoading}>
      <>
        {
          feedback?.type !== undefined
            ?
            <>
              <Result
                icon={<></>}
                subTitle={feedback.message}
                extra={feedback.extra}
              />
              <div className="job-list">
                {
                  relevantJobs.map(job => <Job job={job} key={job.uid} />)
                }
              </div>
            </>
            :
            <ParametersForm
              form={parametersForm}
              initialValues={initialValues}
              functionality={functionality}
              {...props}
            />
        }
        <div className="action-button-container">
          {
            feedback?.type === undefined
              ?
              <Button
                onClick={() => {
                  startPolling(fetchAndStore)
                  RunWithParams()
                }}
                type="primary"
              >
                Run now
              </Button>
              :
              <Button
                onClick={() => setFeedback(undefined)}
                type="primary"
              >
                Back
              </Button>
          }
        </div>
      </>
    </Skeleton>
  );
};
